import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getStorefrontSettings, type StorefrontSettings } from '../composables/useStorefrontApi'

export const useSettingsStore = defineStore('settings', () => {
    const settings = ref<StorefrontSettings | null>(null)
    const isLoading = ref(true)
    const error = ref<string | null>(null)

    async function fetchSettings() {
        // Try to load from localStorage first for immediate display
        const cached = localStorage.getItem('storefront-settings')
        if (cached && !settings.value) {
            try {
                settings.value = JSON.parse(cached)
            } catch (e) {
                console.error('Failed to parse cached settings', e)
            }
        }

        // If we have settings from cache, we can stop "loading" for the UI immediately
        if (settings.value) {
            isLoading.value = false
        }

        error.value = null

        try {
            // Always fetch latest settings in background/foreground
            const data = await getStorefrontSettings()
            if (data) {
                settings.value = data
                localStorage.setItem('storefront-settings', JSON.stringify(data))
            }
        } catch (e: any) {
            error.value = e.message
            // If fetch fails but we have cached settings, we can silently fail or show a toast
            // For now, we keep the cached settings if available
        } finally {
            isLoading.value = false
        }
    }

    return {
        settings,
        isLoading,
        error,
        fetchSettings
    }
})
